import React, { useState, useEffect, memo } from 'react'
import FilterColumn from './filter_column'
import { useSelector, useDispatch } from 'react-redux'
import { SET_SELECTED_FILTER } from 'estimate_list/reducers/initial'
import { numberFormat, filterTheorem } from 'estimate_list/libs/util'
import styled from 'styled-components'

const FilterPrice = () => {
    const setSearchPriceOption = useSelector(state => state.initial.setSearchPriceOption)
    const selectedFilters = useSelector(state => state.initial.selectedFilters)
    const selectCategory = useSelector(state => state.initial.selectCategory)
    const { srch_cond } = useSelector(state => state.initial.route)

    const [minPrice, setMinPrice] = useState('')
    const [maxPrice, setMaxPrice] = useState('')

    const [minPlaceHolder, setMinPlaceHolder] = useState(0)
    const [maxPlaceHolder, setMaxPlaceHolder] = useState(0)


    const pricelength = setSearchPriceOption?.list?.length
    const totalcount = setSearchPriceOption?.totalcount
    const list = setSearchPriceOption?.list

    const dispatch = useDispatch()

    /**
     * 가격 구간 정보가 있으면
     * placeholder 정보를 수정
     */

    useEffect(() => {
        if(selectedFilters.min === 0 && selectedFilters.max === 0){
            setMinPlaceHolder('0')
            if(totalcount && list){
                setMaxPlaceHolder(list[totalcount-1].lim_price_high);
            } else setMaxPlaceHolder(0)
        }else{
            setMinPlaceHolder('');
            setMaxPlaceHolder('')
        }
    }, [selectedFilters.min, selectedFilters.max, setSearchPriceOption, selectCategory])

    /**
     * 카테고리가 변경 될 경우 input 창에 입력된 value 초기화
     */
    useEffect(() => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'price',
                value: [0, 0]
            })
        })

        setMinPrice('' );
        setMaxPrice('');
    }, [selectCategory]);

    /**
     * 가격 구간 검색 후, 하단의 검색 구간 삭제 시 입력된 value 초기화
     */
    useEffect(() => {
        if(srch_cond === null){
            dispatch({
                type: SET_SELECTED_FILTER,
                data: filterTheorem(selectedFilters, {
                    kind: 'price',
                    value: [0, 0]
                })
            })

            setMinPrice('' );
            setMaxPrice('');
        }
    }, [srch_cond]);





    const priceDataSet = num => {
        const price = num.replace(/,/g, '')
        const re = /^[0-9\b]+$/

        if (!re.test(price) || price.length > 14) {   // 숫자 외 입력했거나 글자수 15자이상
            if (price === '') {
                return ''
            }
            return false
        }
        return price
    }

    const onChangeMinPrice = (e) => {
        const price = Number(priceDataSet(Number(e.target.value) < 0 ? '0' : e.target.value))
        if (price !== false) {
            setMinPrice(price)
        }
    }

    const onChangeMaxPrice = (e) => {
        const price = Number(priceDataSet(e.target.value))
        if (price !== false) {
            setMaxPrice(price)
        }
    }

    const onClickPriceFilter = () => {

        if(minPrice === '' && maxPrice ==='') return
        let min = 0;
        let max = 0;

        if(pricelength){
            if(minPrice && maxPrice ===''){
                min = parseInt(minPrice, 10);
                max = setSearchPriceOption?.list[(setSearchPriceOption?.list?.length) - 1]?.lim_price_high;
            } else if(minPrice ==='' && maxPrice){
                min = 0
                max = parseInt(maxPrice, 10)
            } else{
               if(Number(minPrice) > Number(maxPrice)){
                   min = parseInt(maxPrice, 10)
                   max = parseInt(minPrice, 10);
                   setMinPrice(min)
                   setMaxPrice(max)
               } else {
                   min = parseInt(minPrice, 10)
                   max = parseInt(maxPrice, 10);
               }
            }
        } else {
            if(minPrice && maxPrice ===''){
                min = parseInt(minPrice, 10);
                max =''
            } else if(minPrice ==='' && maxPrice){
                min = 0
                max = parseInt(maxPrice, 10)
            } else{
                if(Number(minPrice) > Number(maxPrice)){
                    min = parseInt(maxPrice, 10)
                    max = parseInt(minPrice, 10);
                    setMinPrice(min)
                    setMaxPrice(max)
                } else {
                    min = parseInt(minPrice, 10)
                    max = parseInt(maxPrice, 10);
                }
            }
        }

        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'price',
                value: [min, max]
            })
        })
    }

    const priceFomat = (id, low, high, length) => {

        let trans = ''
        if (id === 1) { // first
            trans = `${wonFomat(high)}이하`
        } else if (id === length) { // last
            trans = `${wonFomat(low)}이상`
        } else {
            trans = `${wonFomat(low)} ~ ${wonFomat(high)}`
        }
        return trans
    }

    /**
     * 첫째, 구간 포인트의 금액이 10만원 이상이라면 만원단위로 표기
     *
     * 둘째, 구간 포인트의 금액이 10만원 미만이라면 천원단위로 표기
     *
     * 셋째, 구간 포인트의 금액이 1만원 미만이라면 천원단위 미만을 구간 단위로 설정하지 않음
     *
     * @param price
     * @returns {`${string}만${string}천원`|`${string}원`|`${string}천원`|`${string}만원`}
     */
    const wonFomat = price => {
        const str = price.toString()
        const strLength = str.length

        if (strLength > 4) {
            const man = str.substr(0, strLength - 4)
            const cheon = str.substr(strLength - 4, 1)
            if (cheon !== '0') {
                return `${man}만${cheon}천원`
            } else {
                return `${man}만원`
            }
        } else if (strLength > 3) {
            const trans =  str.substr(0, strLength - 3)
            return `${trans}천원`
        } else {
            return `${price}원`
        }
    }

    const onClickPrice = (low, high) => () => {

        const { min, max } = selectedFilters
        if(min === low && max === high){
            dispatch({
                type: SET_SELECTED_FILTER,
                data: filterTheorem(selectedFilters, {
                    kind: 'price',
                    value: [0, 0]
                })
            })

            setMinPrice('' );
            setMaxPrice('');
        } else {
            dispatch({
                type: SET_SELECTED_FILTER,
                data: filterTheorem(selectedFilters, {
                    kind: 'price',
                    value: [low, high]
                })
            })

            setMinPrice(low);
            setMaxPrice(high);
        }
    }


    const activeFilter = (low, high) => {

        const { min, max } = selectedFilters
        let flag = ''
        if (low === min && high === max) {
            flag = 'active'
        }
        return flag
    }

    const onKeyPressPrice = e => {
        if (e.key === 'Enter') {
            onClickPriceFilter()
        }
    }

    const handleMinPlaceHolder = () => {
        const lowestPricePlaceHolder = numberFormat(minPlaceHolder)
        if (lowestPricePlaceHolder === '') {
            return 0
        } else {
            return lowestPricePlaceHolder
        }
    }

    const handleMinPrice = () => {
        const price = numberFormat(minPrice)
        if (price === '0') {
            return ''
        } else {
            return price
        }
    }

    /**
     * 240610
     * (maxPrice, setSearchPriceOption)
     * setSearchPriceOption값을 전달 받는데 사용하지않아서 setSearchPriceOption제거
     * */
    const handleMaxPrice = (maxPrice) => {
        // 마지막 xx만원 이상 구간 선택 시 최대값에 입력값이 안들어가도록 하는 로직
        // if (Array.isArray(setSearchPriceOption?.list) && (maxPrice >= setSearchPriceOption?.list[(setSearchPriceOption?.list?.length) - 1]?.lim_price_high)) {
        //     return '';
        // } else {
        //     return numberFormat(maxPrice);
        // }

        // 마지막 가격 구간에도 최대값이 들어가도록 변경 (23/04/06)
        return numberFormat(maxPrice);
    }

    return (
        <FilterColumn title="가격" pricelength={pricelength}>
            <div className="row">
                <div className="etc_inner etc_price">
                    <ul className="title_list">
                        {setSearchPriceOption?.list?.map((v, _) => (
                            <li key={v.sec_id} className={activeFilter(v.lim_price_low, v.lim_price_high)}>
                                <button type="button" onClick={onClickPrice(v.lim_price_low, v.lim_price_high)}>
                                    <span className="text">
                                        {priceFomat(v.sec_id, v.lim_price_low, v.lim_price_high, setSearchPriceOption?.list?.length)}
                                    </span>
                                    {/*<i className="icon-close" />*/}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="range">
                        <span className="range_txt">직접입력</span>
                        <span className="range_input">
                            <InputPrice
                                type="text"
                                title="최소가격 입력"
                                onChange={onChangeMinPrice}
                                onKeyPress={onKeyPressPrice}
                                onFocus={(e) => e.target.select()}
                                value={handleMinPrice()}
                                placeholder={handleMinPlaceHolder()}
                            />
                            원
                        </span>
                        <span className="range_at">~</span>
                        <span className="range_input">
                            <InputPrice
                                type="text"
                                title="최대가격 입력"
                                onChange={onChangeMaxPrice}
                                onKeyPress={onKeyPressPrice}
                                onFocus={(e) => e.target.select()}
                                placeholder={numberFormat(maxPlaceHolder)}
                                value={handleMaxPrice(maxPrice)}
                            />
                            원
                        </span>
                        <button type="button" className="price_search" onClick={onClickPriceFilter}>
                            가격대 검색 <i className="icon-search1" />
                        </button>
                    </div>
                </div>
                <div className="cell">
                    <ul className="list">
                        {setSearchPriceOption?.list?.map((v, _) => (
                            <li key={v.sec_id} className={activeFilter(v.lim_price_low, v.lim_price_high)}>
                                <button type="button" onClick={onClickPrice(v.lim_price_low, v.lim_price_high)}>
                                    <span className="text">
                                        {priceFomat(v.sec_id, v.lim_price_low, v.lim_price_high, setSearchPriceOption.list.length)}
                                    </span>
                                    {/*<i className="icon-close" />*/}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </FilterColumn>
    )
}

export default memo(FilterPrice)

const InputPrice = styled.input`
    ::placeholder{
        color: #c8c8c8;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_price.js